



































import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import {
  Category,
  Status,
  Tile,
  TaskDetailParam,
  TaskAttributeGroup,
} from '@/@types/LibraryComponent';

@Component
export default class SelectMenu extends Vue {
  @Prop({ default: null })
  private readonly taskId!: number | null;
  /** カテゴリー名、優先度名など */
  @Prop()
  public name!: string;
  /** カテゴリー、優先度、ステータスの値に対応したrgb値を持つオブジェクト */
  @Prop()
  private tiles!: Tile[] | TaskAttributeGroup[];
  @Prop()
  private attribute!: string;
  @Prop({ default: false })
  private customFlag!: boolean;
  private displayName: string | null = '';
  @Prop()
  public isTaskDetailModal!: boolean;
  @Prop()
  public isTaskDetailModalHeaderRight!: boolean;

  @Emit('emitTaskData')
  private emitTaskData(tile: Tile | Category | Status): TaskDetailParam {
    this.displayName = tile.title;
    if (this.customFlag) {
      const value: Tile = tile as Tile;
      return {
        taskId: this.taskId,
        value: value.taskAttributeValueOptionId,
        attributeKey: this.attribute,
        customFlag: this.customFlag,
      };
    } else {
      return {
        taskId: this.taskId,
        value: tile.title as string,
        attributeKey: this.attribute,
        customFlag: this.customFlag,
      };
    }
  }

  private mounted() {
    this.displayName = this.name;
  }

  /**
   * タスクのプロパティから対象のオブジェクトを取得、更にそのオブジェクトのプロパティからstyleの情報を取得
   */
  private getTileStyleInfo(): {
    background: string;
    color: string;
  } | void {
    const tile = this.tiles.find((c: Tile | TaskAttributeGroup) => c.title === this.displayName);
    if (tile) {
      /** 見づらいので、暫定的に背景色を白にしている */
      if (tile.backgroundColor === null) tile.backgroundColor = 'white';
      return { background: tile.backgroundColor, color: tile.fontColor };
    }
  }
}
